import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { NumberTypeEnum } from '@/enums/NumberTypeEnums';
import { FieldEventTypeEnums } from '@/enums/FieldEventTypeEnums';
import { ConfigurationValueSelect } from '@/models/configuration/ValuesSelect';
import { ApiIdentifers } from '@/config/index';
import { LoggerService, UnitsHelper } from '@/utils';
import { AxDataService, ConfigurationService } from '@/services/index';
import { MachineFieldTypeEnums } from '@/enums/MachineFieldTypeEnums';
import { Helpers } from '@/helpers/Helpers';
import { UserProfile } from '@/models/dexie/UserProfile';
import { UserProfileStore } from '@/store/store.userProfile';
import { ConfigurationSection } from '@/models/configuration/Section';
import { FilterNumberRangeTypeEnum } from '@/enums/FilterNumberRangeTypeEnum';
import { ConfigurationFilterField } from '@/models/filter/ConfigurationFilterField';

export interface IFilterFieldComponentMethods {
    validateField(): boolean;
    setFieldError(hasError: boolean): void;
}

export interface IFilterFielddEvent {
    type: FieldEventTypeEnums;
    value: any;
}

@Component
export default class FilterFieldComponent extends Vue implements IFilterFieldComponentMethods {
    @PropSync('field', { type: Object }) public syncedField!: ConfigurationFilterField;
    @PropSync('fields', { type: Array }) public syncedFields!: ConfigurationFilterField[];
    @PropSync('editValue', { type: Boolean, default: true }) public syncedEditValue!: boolean;
    @PropSync('previewReadonly', { type: Boolean, default: false }) public previewReadonlyValue!: boolean;

    public text: string = '';
    public selectValue: number[] | string[] | ConfigurationValueSelect[] | null | undefined = null;
    public selectData: ConfigurationValueSelect[] = [];
    public maxTextLength: number | null = null;

    public axSelectData: ConfigurationValueSelect[] = [];
    public axSelectDisabled = true;
    public axDefaultText: string = '';
    public axIsLoading: boolean = false;

    public numberValueFrom: number[] | null = null;
    public numberValueStringFrom: string = '';
    public numberMinFrom: number = 0;
    public numberMaxFrom: number = 100;
    public numberValueTo: number | null = null;
    public numberValueStringTo: string = '';
    public numberMinTo: number = 0;
    public numberMaxTo: number = 100;
    public numberStep: number = 1;
    public numberType: NumberTypeEnum = NumberTypeEnum.INTEGER;
    public numberRangeType: FilterNumberRangeTypeEnum = FilterNumberRangeTypeEnum.RANGE;
    public numberRangeTypes = FilterNumberRangeTypeEnum;
    public numbersDisabled: boolean = false;
    public numbersSuffix: string | null = null;

    public menu: boolean = false;
    public menu2: boolean = false;
    public dateFrom: string = '';
    public dateTo: string = '';

    public changeTimeout: any = null;
    public isValid: boolean = true;
    public unitInvalidOrMandatory: boolean = false;
    public numberInvalidOrMandatory: boolean = false;

    public checkboxValue: boolean = false;

    public fte = FieldTypeEnum;
    public errorMessage: string = '';

    private emitEvent: boolean = true;
    private lastIdentifier?: string;
    private skipNextCheck: boolean = false;

    public mounted() {
        this.prepareField();
        this.setInitalValue();
    }

    public updated() {
        this.checkForClearButton();
    }

    public beforeDestroy() {
        AxDataService.OnSelectedCustomersChanged.off(this.onSelectedCustomersChanged);
        AxDataService.OnAxFilteredCustomersChanged.off(this.setCustomerData);
        AxDataService.OnAxFilterCustomersStarted.off(this.setAxLoading);
    }

    public prepareField() {
        if (this.syncedField.type === FieldTypeEnum.NUMBER) {
            this.numberMinFrom = this.syncedField.min || 0;
            this.numberMaxFrom = this.syncedField.max || 100;
            this.numberMinTo = this.syncedField.min || 0;
            this.numberMaxTo = this.syncedField.max || 100;
            this.numberStep = this.syncedField.rangeStep != null ? this.syncedField.rangeStep : this.getRangeStep();

            this.getNumberSuffix();

            // // if Blend% then set to 100% by default
            // if (this.syncedField.identifier === ApiIdentifers.materialBlend && this.syncedField.valueNumber === undefined) {
            //     this.numberValueFrom = 100;
            //     this.numberValueStringFrom = '100';
            //     this.syncedField.valueNumber = 100;
            // }
        } else if (this.syncedField.type === FieldTypeEnum.DATE) {
            if (this.syncedField.valueString && this.syncedField.valueString!.length <= 0) {
                // this.dateFrom = new Date().toISOString().substr(0, 10);
            } else if (this.syncedField.valueString) {
                this.dateFrom = new Date(this.syncedField.valueString[0]).toISOString().substring(0, 10);
            }
        } else if (this.syncedField.type === FieldTypeEnum.TEXT || this.syncedField.type === FieldTypeEnum.TEXTAREA) {
            if (this.syncedField.max) {
                this.maxTextLength = this.syncedField.max;
            }
        } else if (this.syncedField.type === FieldTypeEnum.UNIT) {
            const unit = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === this.syncedField.unitIdentifier);
            if (unit !== undefined) {
                this.selectData = unit.values || [];
            }
        } else if (this.syncedField.type === FieldTypeEnum.AXSELECT) {
            if (this.syncedField.identifier === ApiIdentifers.axCustomerName) {
                this.getAxFieldDataCustomer();
                this.axDefaultText = '';
            } else if (
                this.syncedField.identifier === ApiIdentifers.axCustomerNumber ||
                this.syncedField.identifier === ApiIdentifers.axAddress ||
                this.syncedField.identifier === ApiIdentifers.axCountry ||
                this.syncedField.identifier === ApiIdentifers.generalAXProject
            ) {
                this.axDefaultText = this.$vuetify.lang.t('$vuetify.edit.defaultAxField');
                AxDataService.OnSelectedCustomersChanged.on(this.onSelectedCustomersChanged);
                /**
                 * In case we already have a selected customer,
                 * e.g. if we open a section that was not yet mounted
                 */
                if (AxDataService.selectedCustomers !== undefined) {
                    this.getAxFieldDataCustomer();
                }
            } else if (ApiIdentifers.machineModels.some((mm) => mm === this.syncedField.identifier)) {
                this.axDefaultText = '';

                this.axSelectDisabled = false;
                this.checkAxMachineField(this.syncedField.identifier);
            }
        }
    }

    public onSelectedCustomersChanged(): void {
        this.getAxFieldDataCustomer();
    }

    public onValueChanged() {
        // if (this.syncedField.type === FieldTypeEnum.CHECKBOX && this.syncedField.identifier === ApiIdentifers.machineOrderAll && this.emitEvent === true) {
        //     this.fieldEvent({ type: FieldEventTypeEnums.CHECKBOX_ALL, value: this.checkboxValue });
        // }

        if (this.emitEvent === false) {
            this.emitEvent = true;
        }
    }

    @Emit()
    public fieldEvent(event: IFilterFielddEvent): IFilterFielddEvent {
        return event;
    }

    @Emit()
    public unitChanged(field: ConfigurationFilterField): ConfigurationFilterField {
        return field;
    }

    @Watch('syncedField', { deep: true })
    public onSyncedFieldChanged(newValue: ConfigurationFilterField) {
        this.emitEvent = false;
        if (this.lastIdentifier && this.lastIdentifier !== newValue.identifier) {
            this.prepareField();
        }
        this.lastIdentifier = newValue.identifier;
        this.setValue(newValue);
        this.checkIsValid();
    }

    @Watch('text')
    public onTextChanged(newVal?: string, oldVal?: string) {
        if (this.changeTimeout != null) {
            clearTimeout(this.changeTimeout);
            this.changeTimeout = null;
        }
        this.changeTimeout = setTimeout(() => {
            if (this.syncedField.identifier === ApiIdentifers.axSearchSerialnumber) {
                this.axIsLoading = true;
                if (newVal != null && newVal.length >= 5) {
                    AxDataService.FilterCustomersBySerialnumber(newVal).finally(() => {
                        this.axIsLoading = false;
                    });
                } else {
                    AxDataService.GetAllCustomerNames().finally(() => {
                        this.axIsLoading = false;
                    });
                }
            } else if (newVal != null && newVal.length === 0) {
                /**
                 * if text input is deleted manuel with del or backspace key
                 * we need to set the field undefined instead of empty string
                 */
                this.syncedField.valueString = undefined;
            } else {
                this.syncedField.valueString = newVal;
            }
            this.onValueChanged();
        }, 500);
    }

    // @Watch('numberValueString')
    // public async onNumberValueStringChanged(newVal: string, oldVal: string) {
    //     if (newVal !== oldVal) {
    //         if (this.changeTimeout != null) {
    //             clearTimeout(this.changeTimeout);
    //             this.changeTimeout = null;
    //         }
    //         this.changeTimeout = setTimeout(() => {
    //             this.numberValueFrom = parseFloat(newVal);
    //         }, 500);
    //     } else {
    //         LoggerService.LogDebug(`onNumberValueStringChanged value did not change: ${oldVal} --> ${newVal}`);
    //     }
    // }
    public async onNumberValueStringChanged(newVal: string, isTo: boolean = false) {
        if (this.changeTimeout != null) {
            clearTimeout(this.changeTimeout);
            this.changeTimeout = null;
        }
        this.changeTimeout = setTimeout(() => {
            this.validateField();
            if (isTo) {
                this.numberValueTo = parseFloat(newVal);
            } else {
                if (this.numberValueFrom == null) {
                    this.numberValueFrom = [];
                }
                this.numberValueFrom[0] = parseFloat(newVal);
            }
        }, 500);
    }

    @Watch('numberValueFrom')
    public async onNumberFromValueChanged(newVal?: number[], oldVal?: number) {
        if (newVal == null || isNaN(newVal[0])) {
            this.syncedField.valueNumber = undefined;
        } else {
            this.syncedField.valueNumber = this.numberValueFrom;
        }
        await this.testNumber();
        this.onValueChanged();
    }

    @Watch('numberValueTo')
    public async onNumberToValueChanged(newVal?: number, oldVal?: number) {
        if (newVal == null || isNaN(newVal)) {
            this.syncedField.valueNumberTo = undefined;
        } else {
            this.syncedField.valueNumberTo = this.numberValueTo;
        }
        await this.testNumber();
        this.onValueChanged();
    }

    @Watch('selectValue')
    public onSelectValueChanged(newVal?: number[] | string[] | ConfigurationValueSelect[], oldVal?: number[] | string[] | ConfigurationValueSelect[]) {
        /**
         * Add a double check for  old and new value here.
         * Since we use the autocomplete field here it get's a bit
         * tricky with setting and watching the values.
         * So as a quickfix we just check if last added value is
         * the same as newVal.
         * See: https://appsfactory.atlassian.net/browse/TTDB-906
         */
        if (newVal != null && oldVal != null && newVal.length > 0 && oldVal.length > 0) {
            const newValItem = newVal[newVal.length - 1];
            const oldValItem = oldVal[oldVal.length - 1];
            if (typeof newValItem === 'object' && typeof oldValItem === 'object' && newValItem.text === oldValItem.text) {
                return;
            } else if (newValItem === oldValItem) {
                return;
            }
        }

        if (newVal == null || newVal.length === 0) {
            this.syncedField.valueString = undefined;
            this.syncedField.valueNumber = undefined;
            this.syncedField.valueAXStrings = undefined;
            if (this.syncedField.identifier === ApiIdentifers.axCustomerName) {
                AxDataService.SetSelectedCustomers();
            }
        } else if (this.syncedField.type === FieldTypeEnum.AXSELECT) {
            this.syncedField.valueAXStrings = [];
            if (typeof newVal === 'object') {
                (newVal as any[]).forEach((val) => {
                    this.syncedField.valueAXStrings!.push(
                        new ConfigurationValueSelect({
                            text: val.text,
                            value: val.value,
                        }),
                    );
                });
            } else {
                (newVal as any[]).forEach((val) => {
                    this.syncedField.valueAXStrings!.push(
                        new ConfigurationValueSelect({
                            text: val.toString(),
                            value: val.toString(),
                        }),
                    );
                });
            }

            if (this.syncedField.identifier === ApiIdentifers.axCustomerName) {
                AxDataService.SetSelectedCustomers(this.syncedField.valueAXStrings.map((x) => x.text));
            }
        } else {
            this.syncedField.valueNumber = newVal as number[];
        }
        this.onValueChanged();
    }

    @Watch('dateFrom')
    public onDateFromChanged(newVal: string) {
        if (newVal) {
            this.syncedField.valueString = new Date(newVal).toISOString();
        } else {
            this.syncedField.valueString = undefined;
        }
        this.onValueChanged();
    }

    @Watch('dateTo')
    public onDateToChanged(newVal: string) {
        if (newVal) {
            this.syncedField.valueStringTo = new Date(newVal).toISOString();
        } else {
            this.syncedField.valueStringTo = undefined;
        }
        this.onValueChanged();
    }

    @Watch('numberRangeType')
    public onNumberRangeType(newVal: FilterNumberRangeTypeEnum) {
        if (newVal === FilterNumberRangeTypeEnum.ALL) {
            if (this.numberValueFrom == null) {
                this.numberValueFrom = [];
            }
            this.numberValueFrom[0] = this.syncedField.min || 0;
            this.numberValueTo = this.syncedField.max || null;
            this.numberValueStringFrom = (this.syncedField.min != null && this.syncedField.min.toString()) || '';
            this.numberValueStringTo = (this.syncedField.max != null && this.syncedField.max.toString()) || '';
            this.numbersDisabled = true;
            this.syncedField.valueBool = true;
        } else {
            this.numberValueFrom = null;
            this.numberValueTo = null;
            this.numberValueStringFrom = '';
            this.numberValueStringTo = '';
            this.numbersDisabled = false;
            this.syncedField.valueBool = false;
        }
        // this.syncedField.valueString = new Date(newVal).toISOString();
        this.onValueChanged();
    }

    get getUserProfile(): UserProfile {
        return UserProfileStore.userProfile;
    }

    // @Watch('checkboxValue')
    // public onCheckboxValueChanged(newVal: boolean, oldVal: boolean) {
    //     /* Somehow there is a case where newValue is undefined, not sure how this happens
    //      * ignore this case for now, investigate later?
    //      */
    //     if (newVal !== undefined) {
    //         this.syncedField.valueBool = newVal;
    //         this.onValueChanged();
    //     } else {
    //         LoggerService.LogDebug(`skipping onCheckboxValueChanged ${oldVal} --> ${newVal}`);
    //     }
    // }

    public onMenuOneSave(inDate: string): void {
        const menu = this.$refs.menu;
        if (menu) {
            (menu as any).save(inDate);
        }
    }

    public onMenuTwoSave(inDate: string): void {
        const menu2 = this.$refs.menu2;
        if (menu2) {
            (menu2 as any).save(inDate);
        }
    }

    public onCheckboxValueChanged(inEvent: boolean) {
        if (this.getCheckBoxDisabled() === false) {
            this.emitEvent = true;
            this.syncedField.valueBool = inEvent;
            this.onValueChanged();
        } else {
            /**
             * Workarround to disable button in create/edit form
             * when machine section was added via the add button
             */
            this.$nextTick(() => {
                this.checkboxValue = this.syncedField.valueBool || false;
            });
        }
    }

    public onFocus(to: boolean) {
        if (to) {
            this.menu = false;
            this.menu2 = true;
        } else {
            this.menu = true;
            this.menu2 = false;
        }
    }

    @Watch('isValid')
    public onIsValidChanged(newVal: boolean, oldVal: boolean) {
        LoggerService.LogDebug(`isValid ${oldVal} --> ${newVal}`);
    }

    public getTypeAsString(type: FieldTypeEnum): string {
        let typeString = '';
        typeString = FieldTypeEnum[type];

        return typeString;
    }

    public getSelectData() {
        this.selectData.splice(0, this.selectData.length);
        if (this.syncedField.values && this.syncedField.values.length > 0) {
            this.syncedField.values.forEach((element: any) => {
                this.selectData.push(new ConfigurationValueSelect(element));
            });
        }
        return this.selectData;
    }

    public async testNumber() {
        LoggerService.LogDebug(`testNumber: ${this.numberValueFrom}`);
        const self = this;
        if (this.numberValueFrom != null && this.syncedField.numericType === NumberTypeEnum.INTEGER) {
            await this.$nextTick(() => {
                if (self.numberValueFrom) {
                    self.numberValueFrom[0] = parseInt(self.numberValueFrom[0].toFixed(0), 10);
                    self.numberValueStringFrom = self.numberValueFrom.toString();
                }
            });
        } else if (this.numberValueFrom != null && this.syncedField.numericType === NumberTypeEnum.DOUBLE) {
            await this.$nextTick(() => {
                if (self.numberValueFrom && this.syncedField.rangeStep) {
                    self.numberValueFrom[0] = parseFloat(self.numberValueFrom[0].toFixed(self.getPrecision(this.syncedField.rangeStep)));
                    self.numberValueStringFrom = self.numberValueFrom.toString();
                }
            });
        } else if (this.numberValueFrom != null) {
            await this.$nextTick(() => {
                if (self.numberValueFrom) {
                    self.numberValueFrom[0] = parseFloat(self.numberValueFrom[0].toFixed(self.getPrecision(self.numberStep)));
                    self.numberValueStringFrom = self.numberValueFrom.toString();
                }
            });
        }

        if (this.numberValueFrom != null && this.numberValueFrom[0] > this.numberMaxFrom) {
            await this.$nextTick(() => {
                if (self.numberValueFrom != null) {
                    self.numberValueFrom[0] = self.numberMaxFrom;
                    self.numberValueStringFrom = self.numberMaxFrom.toString();
                }
            });
        } else if (this.numberValueFrom != null && this.numberValueFrom[0] < this.numberMinFrom) {
            await this.$nextTick(() => {
                if (self.numberValueFrom != null) {
                    self.numberValueFrom[0] = self.numberMinFrom;
                    self.numberValueStringFrom = self.numberMinFrom.toString();
                }
            });
        }
    }

    public allowedDates(inValue: any) {
        // LoggerService.LogDebug(`allowedDates: `, inValue);
        const now = new Date();
        let isValid = true;
        if (new Date(inValue).getTime() > now.getTime()) {
            isValid = false;
        }
        return isValid;
    }

    public validateField(forceCheck: boolean = false): boolean {
        return this.checkIsValid(forceCheck);
    }

    public getNumberSuffix(): void {
        let unitString = null;
        if (this.syncedField.fixedUnit) {
            unitString = this.syncedField.fixedUnit;
        } else if (this.syncedField.unit) {
            const unitField = this.syncedFields.find((f) => f.identifier === this.syncedField.unit);
            if (unitField) {
                const unit = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === unitField.unitIdentifier);
                if (unit) {
                    const unitModel = unit.values && unit.values.find((v) => v.value === unit.base);
                    if (unitModel) {
                        unitString = unitModel.text;
                    }
                }
            }
        }
        this.numbersSuffix = unitString;
    }

    public up(to: boolean = false) {
        // previous week
        const pickedDate = new Date(this.dateFrom);
        pickedDate.setDate(pickedDate.getDate() - 7);
        if (to) {
            this.dateTo = pickedDate.toISOString().substring(0, 10);
        } else {
            this.dateFrom = pickedDate.toISOString().substring(0, 10);
        }
    }

    public down(to: boolean = false) {
        // next week
        const pickedDate = new Date(this.dateFrom);
        pickedDate.setDate(pickedDate.getDate() + 7);
        this.dateFrom = pickedDate.toISOString().substring(0, 10);
    }

    public left(e: KeyboardEvent, to: boolean = false) {
        // previous month with shift key otherwise previous day
        const pickedDate = new Date(this.dateFrom);
        if (e.shiftKey) {
            pickedDate.setMonth(pickedDate.getMonth() - 1);
        } else {
            pickedDate.setDate(pickedDate.getDate() - 1);
        }
        this.dateFrom = pickedDate.toISOString().substring(0, 10);
    }

    public right(e: KeyboardEvent, to: boolean = false) {
        // next month with shift key otherwise next day
        const pickedDate = new Date(this.dateFrom);
        if (e.shiftKey) {
            pickedDate.setMonth(pickedDate.getMonth() + 1);
        } else {
            pickedDate.setDate(pickedDate.getDate() + 1);
        }
        this.dateFrom = pickedDate.toISOString().substring(0, 10);
    }

    /**
     * Method to fetch translation with fallback
     * @param field ConfigurationSection
     */
    public getIdentifierText(inType?: string): string {
        let ret: string = '';
        if (this.syncedField && this.syncedField.identifier) {
            ret = this.$vuetify.lang.t(`$vuetify.identifiers.${this.syncedField.identifier}`);

            if (ret.length === 0 || ret.includes('$vuetify.identifiers.')) {
                ret = this.syncedField.name;
            }
        }
        if (inType && inType === 'from') {
            ret = this.$vuetify.lang.t(`$vuetify.filter.dateFrom`, ret);
        } else if (inType && inType === 'to') {
            ret = this.$vuetify.lang.t(`$vuetify.filter.dateTo`, ret);
        }

        return ret;
    }

    public async getAxFieldDataCustomer() {
        if (this.syncedField.identifier === ApiIdentifers.axCustomerName) {
            this.axSelectDisabled = false;
            this.axDefaultText = '';
            AxDataService.OnAxFilterCustomersStarted.off(this.setAxLoading);
            AxDataService.OnAxFilteredCustomersChanged.off(this.setCustomerData);
            AxDataService.OnAxFilterCustomersStarted.on(this.setAxLoading);
            AxDataService.OnAxFilteredCustomersChanged.on(this.setCustomerData);
            await AxDataService.GetAllCustomerNames()
                .then((data) => {
                    this.axSelectData = AxDataService.axFilteredCustomers;
                })
                .finally(() => {
                    this.axIsLoading = false;
                });
        } else {
            if (AxDataService.selectedCustomers !== undefined) {
                this.axDefaultText = '';
                switch (this.syncedField.identifier) {
                    case ApiIdentifers.axCustomerNumber:
                        this.axSelectData = AxDataService.selectedCustomerNumbers;
                        break;
                    case ApiIdentifers.axCountry:
                        this.axSelectDisabled = false;
                        this.axSelectData = AxDataService.axAllCountries;
                        break;
                    case ApiIdentifers.generalAXProject:
                        this.axSelectDisabled = false;
                        this.axSelectData = AxDataService.selectedCustomerProjectNumbers;
                        break;
                    case ApiIdentifers.axAddress:
                        this.axSelectDisabled = false;
                        this.axSelectData = AxDataService.selectedCustomerAddresses;
                        break;
                    default:
                        break;
                }
            } else {
                this.selectValue = undefined;
                this.axSelectData = [];
                this.axSelectDisabled = true;
                this.axDefaultText = this.$vuetify.lang.t('$vuetify.edit.defaultAxField');
            }
        }
    }

    public axDataFilter(item: ConfigurationValueSelect, queryText: string, itemText: string): boolean {
        const textOne = item.text.toLowerCase();
        const textTwo = (item.value as string).toLowerCase();
        const searchText = queryText.toLowerCase();

        return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    }

    public setFieldError(hasError: boolean) {
        if (hasError === true) {
            const self = this;
            this.$nextTick(() => {
                self.syncedField.isValid = false;
                self.numberInvalidOrMandatory = true;
                self.skipNextCheck = true;
            });
        }
    }

    public getCheckBoxDisabled(): boolean {
        /**
         * previewReadonlyValue is by default false so use it as initial value.
         * If syncedField.disabled is set and previewReadonlyValue is false, then
         * override it.
         */
        let disabled = this.previewReadonlyValue;
        if (this.syncedField.disabled != null && !disabled) {
            disabled = this.syncedField.disabled;
        }
        return disabled;
    }

    private async checkAxMachineField(inIdentifier: string) {
        const parent = ApiIdentifers.GetSectionIdentifier(inIdentifier);
        if (parent && parent !== '') {
            this.axSelectData = [];
            AxDataService.GetMachineModelsBySectionForFilter(parent).then((data) => {
                LoggerService.debug(`checkAxMachineField:`, data);
                const values: string[] = [];
                data.forEach((mm) => {
                    values.push(mm.model);
                });
                values.forEach((v) => {
                    this.axSelectData.push(
                        new ConfigurationValueSelect({
                            text: v,
                            value: v,
                        }),
                    );
                });
            });
        }
    }

    private checkIsValid(forceCheck: boolean = false): boolean {
        if (this.syncedField === undefined) {
            LoggerService.LogWarn(`checkIsValid has no data`);
            return false;
        }

        /**
         * This is for the unit field check.
         * If a unit is selected but not value
         * entered we need to skip one check to
         * mark the field correct
         */
        if (this.skipNextCheck === true) {
            this.skipNextCheck = false;
            return false;
        }

        if (this.syncedField.type === FieldTypeEnum.TEXTAREA || this.syncedField.type === FieldTypeEnum.TEXT) {
            this.syncedField.isValid = this.checkValue();
            this.isValid = this.syncedField.isValid;
            // if (this.maxTextLength != null && this.maxTextLength > 0) {
            //     this.syncedField.isValid = this.checkValue();
            //     this.isValid = this.syncedField.isValid;
            // } else if (/^\s+$/.test(this.text)) {
            //     this.syncedField.isValid = this.checkValue();
            //     this.isValid = this.syncedField.isValid;
            // }
        }

        if (this.syncedField.type === FieldTypeEnum.UNIT) {
            if (this.isValid === true) {
                this.unitInvalidOrMandatory = false;
            } else {
                this.unitInvalidOrMandatory = true;
            }
        } else if (this.syncedField.type === FieldTypeEnum.NUMBER) {
            if (this.isValid === true) {
                this.numberInvalidOrMandatory = false;
            } else {
                this.numberInvalidOrMandatory = true;
            }
        }

        return this.isValid || false;
    }

    private getRangeStep(): number {
        let numberStringArray = this.numberMaxFrom.toString().split('.');
        if (numberStringArray.length === 1) {
            numberStringArray = this.numberMinFrom.toString().split('.');
        }

        let result: string = '1';
        if (numberStringArray.length > 1) {
            for (let i = 1; i < numberStringArray[1].length; i++) {
                result = '0' + result;
            }
            result = '0.' + result;
        }

        return parseFloat(result);
    }

    private getPrecision(inNumber: number): number {
        const parts = inNumber.toString().split('.');
        let precision = 0;
        if (parts.length > 1) {
            precision = parts[1].length;
        }
        return precision;
    }

    private setValue(newValue: ConfigurationFilterField) {
        if (this.syncedEditValue && this.syncedEditValue === true) {
            switch (this.syncedField.type) {
                case FieldTypeEnum.CHECKBOX:
                    this.checkboxValue = this.syncedField.valueBool || false;
                    break;
                case FieldTypeEnum.DATE:
                    this.dateFrom = (this.syncedField.valueString && this.syncedField.valueString.substr(0, 10)) || '';
                    break;
                case FieldTypeEnum.NUMBER:
                    this.numberValueFrom = this.syncedField.valueNumber != null ? this.syncedField.valueNumber : null;
                    this.numberValueStringFrom = this.syncedField.valueNumber != null ? this.syncedField.valueNumber.toString() : '';
                    break;
                case FieldTypeEnum.TEXT:
                case FieldTypeEnum.TEXTAREA:
                    this.text = this.syncedField.valueString || '';
                    break;
                case FieldTypeEnum.SELECT:
                case FieldTypeEnum.UNIT:
                    this.selectValue = this.syncedField.valueNumber != null ? this.syncedField.valueNumber : null;
                    break;
                case FieldTypeEnum.AXSELECT:
                    this.selectValue = this.syncedField.valueAXStrings != null ? this.syncedField.valueAXStrings : null;
                    break;
                default:
                    break;
            }
        } else {
            switch (this.syncedField.type) {
                case FieldTypeEnum.CHECKBOX:
                    this.checkboxValue = newValue.valueBool || false;
                    break;
                case FieldTypeEnum.UNIT:
                    this.selectValue = newValue.valueNumber;
                    break;
                default:
                    break;
            }
        }
    }

    private checkValue(): boolean {
        let isValid = false;
        switch (this.syncedField.type) {
            case FieldTypeEnum.CHECKBOX:
                isValid = this.checkboxValue !== undefined ? this.checkboxValue : false;
                break;
            case FieldTypeEnum.DATE:
                isValid = this.dateFrom !== undefined && this.dateFrom.length > 0 ? true : false;
                break;
            case FieldTypeEnum.NUMBER:
                isValid = this.numberValueFrom !== undefined && this.numberValueFrom !== null ? this.checkIsNumber(this.numberValueFrom[0]) : false;
                break;
            case FieldTypeEnum.SELECT:
            case FieldTypeEnum.UNIT:
                // isValid = this.selectValue !== undefined && this.selectValue !== null ? this.checkIsNumber(this.selectValue as number) : false;
                break;
            case FieldTypeEnum.AXSELECT:
                isValid = this.selectValue !== undefined && this.selectValue !== null ? this.selectValue.length > 0 : false;
                break;
            case FieldTypeEnum.TEXT:
            case FieldTypeEnum.TEXTAREA:
                if (this.text != null && this.text.length >= 0) {
                    if (/^\s+$/.test(this.text)) {
                        isValid = false;
                        this.errorMessage = isValid ? '' : this.$vuetify.lang.t('$vuetify.filter.validate.textOnlySpace');
                    } else if (this.maxTextLength != null) {
                        isValid = this.text.length <= this.maxTextLength;
                        this.errorMessage = isValid ? '' : this.$vuetify.lang.t('$vuetify.filter.validate.textToLong');
                    } else {
                        isValid = true;
                        this.errorMessage = '';
                    }
                } else if (this.text == null) {
                    isValid = true;
                    this.errorMessage = '';
                } else {
                    isValid = false;
                }
                break;
            default:
                break;
        }

        return isValid;
    }

    private setInitalValue() {
        switch (this.syncedField.type) {
            case FieldTypeEnum.CHECKBOX:
                this.checkboxValue = this.syncedField.valueBool || false;
                break;
            case FieldTypeEnum.DATE:
            case FieldTypeEnum.FILTER_DATE:
                this.dateFrom = (this.syncedField.valueString && this.syncedField.valueString.substring(0, 10)) || '';
                this.dateTo = (this.syncedField.valueStringTo && this.syncedField.valueStringTo.substring(0, 10)) || '';
                break;
            case FieldTypeEnum.NUMBER:
                this.numberValueFrom = this.syncedField.valueNumber != null ? this.syncedField.valueNumber : null;
                this.numberValueStringFrom = this.syncedField.valueNumber != null ? this.syncedField.valueNumber.toString() : '';

                this.numberValueTo = this.syncedField.valueNumberTo != null ? this.syncedField.valueNumberTo : null;
                this.numberValueStringTo = this.syncedField.valueNumberTo != null ? this.syncedField.valueNumberTo.toString() : '';
                this.numberRangeType = this.syncedField.valueBool && this.syncedField.valueBool === true ? FilterNumberRangeTypeEnum.ALL : FilterNumberRangeTypeEnum.RANGE;

                // if (this.numberValueFrom != null && this.syncedField.unit != null) {
                //     let value = '';
                //     if (this.syncedField.unit === ApiIdentifers.unitTemperature) {
                //         // handle temperature extra, format is selected by user profile
                //         value = UnitsHelper.calcByUnit(this.syncedField.unit, this.syncedField.rangeStep, this.syncedField.valueNumber != null ? this.syncedField.valueNumber : 0, 0);
                //     } else {
                //         const unitField = this.syncedFields.find(x => x.identifier === this.syncedField.unit);
                //         if (unitField !== undefined && unitField.unitIdentifier !== undefined) {
                //             value = UnitsHelper.calcByUnit(
                //                 unitField.unitIdentifier,
                //                 this.syncedField.rangeStep,
                //                 this.syncedField.valueNumber != null ? this.syncedField.valueNumber : 0,
                //                 unitField.valueNumber || undefined
                //             );
                //         }
                //     }
                //     this.numberValueFrom = parseFloat(value);
                //     this.numberValueStringFrom = value;
                // }
                break;
            case FieldTypeEnum.TEXT:
            case FieldTypeEnum.TEXTAREA:
                this.text = this.syncedField.valueString || '';
                break;
            case FieldTypeEnum.SELECT:
                this.selectValue = this.syncedField.valueNumber != null ? this.syncedField.valueNumber : null;
                break;
            case FieldTypeEnum.UNIT:
                // if (this.syncedField.identifier === ApiIdentifers.generalUnitFormat) {
                //     this.selectValue = this.syncedField.valueNumber ? this.syncedField.valueNumber : 0;
                // } else {
                //     const userProfileFormat = this.getUserProfile.units.find(upf => upf.unitIdentifier === this.syncedField.unitIdentifier || '');
                //     if (userProfileFormat != null) {
                //         this.selectValue = userProfileFormat.selectedValue;
                //     } else {
                //         this.selectValue = this.syncedField.valueNumber != null ? this.syncedField.valueNumber : null;
                //     }
                // }
                break;
            case FieldTypeEnum.AXSELECT:
                this.selectValue = this.syncedField.valueAXStrings != null ? this.syncedField.valueAXStrings : null;
                if (this.selectValue && this.syncedField.identifier === ApiIdentifers.axCustomerName) {
                    this.axSelectDisabled = true;
                } else if (this.selectValue && this.syncedField.identifier === ApiIdentifers.axCustomerNumber) {
                    this.axSelectDisabled = true;
                    this.axDefaultText = this.$vuetify.lang.t('$vuetify.edit.defaultAxField');
                } else if (this.syncedField.identifier === ApiIdentifers.axCustomerNumber) {
                    this.axSelectDisabled = false;
                }
                break;
            default:
                break;
        }
    }

    private checkIsNumber(inNumber: number): boolean {
        return !isNaN(inNumber);
    }

    private checkForClearButton() {
        /**
         * this check removes the clear button from the tab index
         * so that you can't reach it via tabulator key.
         * See Ticket: https://appsfactory.atlassian.net/browse/TTDB-678
         */
        const fieldRef = Helpers.getReference<Vue>(this.$refs, 'field');
        if (fieldRef != null) {
            for (const child of fieldRef.$children) {
                if (child.$attrs && child.$attrs['aria-label'] != null && child.$attrs['aria-label'] === 'clear icon') {
                    child.$el.setAttribute('tabIndex', '-1');
                }
            }
        }
    }

    private setCustomerData(inData?: ConfigurationValueSelect[]) {
        if (inData) {
            this.axSelectData = inData;
        }
    }
    private setAxLoading() {
        this.axIsLoading = true;
    }
}
